import {Person} from './person';
import {Group} from './group';
import {Role} from './role';

export enum RoleName { IT = 'IT', CustomerService = 'CustomerService', CredAnalyst = 'CredAnalyst', ApplicationEngineer = 'ApplicationEngineer', ReadOnly = 'ReadOnly', RSM = 'RSM'};

export class PersonLogin {

  person!: Person;
  googleId!: string;
  token!: string;
  internalId!: string;
  groups!: Group[];
  roles!: Role[];

}

